import { IStyle } from "@fluentui/react";
import React from "react";

export const containerStyle: React.CSSProperties = {
  display: "flex",
  flexWrap: "wrap",
  gap: "16px"
};

export const cardContainerStyle = (cardWidth?: number): React.CSSProperties => ({
  flex: `0 1 ${cardWidth ?? 0}px`
});

// Fluent UI styles (use with className and mergeStyles)
export const varianceContainerStyle: IStyle = {
  flex: 1,
  overflow: "hidden"
};

export const varianceMetricNameStyle: IStyle = {
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden"
};

// Inline CSSProperties (use with style)
export const currMonthValStyle: React.CSSProperties = {
  fontSize: "14px",
  fontWeight: "600",
  padding: "5px 0 5px 0"
};

export const varianceGreenStyle: React.CSSProperties = {
  color: "green",
  fontWeight: 600,
  display: "flex",
  alignItems: "center"
};

export const varianceRedStyle: React.CSSProperties = {
  color: "red",
  fontWeight: 600,
  display: "flex",
  alignItems: "center"
};

export const rootVarianceStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  background: "#f0f0f0",
  fontSize: "12px",
  padding: "10px",
  paddingTop: 0,
  boxSizing: "border-box"
};

export const rootVarianceStyleSingle: React.CSSProperties = {
  ...rootVarianceStyle,
  justifyContent: "flex-start",
  paddingLeft: "26px"
};
